function generatePdf() {
  // Default export is a4 paper, portrait, using millimeters for units
  const doc = jspdf.jsPDF({
    unit: 'px',
    format: 'a4',

  });
  //global
  var width = doc.internal.pageSize.getWidth();
  var height = doc.internal.pageSize.getHeight();

  let nrb = '17102000456199000100000000';
  let parmNrb = document.querySelector('input[name=nrb').value;

  if(parmNrb.substr(2,10) == '1020004561' || parmNrb == '32116022020000000247781296' || parmNrb == '92116022020000000251040774'|| parmNrb == '86116022020000000251040591'|| parmNrb == '34102010260000150203010469'|| parmNrb == '86102010260000190203010501'|| parmNrb == '44102010260000110203010485' ){
    nrb = parmNrb;
  } 
  
  let nrbt = 'Darowizna na cele statutowe Ordo Iuris';
  if(document.querySelector('input[name=nrbt').value){
    nrbt = document.querySelector('input[name=nrbt').value;
  }

  doc.addFont('OpenSans-Regular', 'regular');
  doc.setFont('OpenSans-Regular');
  doc.addImage(templateUrl+"/img/druczek.jpg", "JPEG", 0, 0, width, height);
  let organization = 'FUNDACJA INSTYTUT NA RZECZ KULTURY PRAWNEJ ORDO IURIS';
  let localization = 'UL. ZIELNA 39, 00-108 WARSZAWA';

  //first block
  doc.text(organization, 30, 24);
  doc.text(localization, 30, 50);
  doc.text(nrb, 32, 76,  { charSpace: '8.5' });
  doc.text(nrbt, 30, 202);

  //second block
  doc.text(organization, 30, 338);
  doc.text(localization, 30, 364);
  doc.text(nrb, 32, 389, { charSpace: '8.5' });
  doc.text(nrbt, 30, 516);

  
  // output
  if(window.innerWidth < 768){

  }
  else{
    var string = doc.output('datauristring');
    var embed = "<iframe width='100%' height='100%' style='min-height: 600px' src='" + string + "'></iframe>"
    let pdfWrapper = document.querySelector('#pdfEmbed');
    pdfWrapper.innerHTML = embed;
  }
  



  document.querySelector('#pdfbtn-download').addEventListener('click', function(){
    doc.save('druczek.pdf');
  });

  

}
// generatePdf();


function init_pdf(){
  let post_office_payment = document.querySelector('#bank-157');

  var popup = document.querySelector(".popup-page");
  if (post_office_payment.classList.contains('tpay-active')) {
    event.preventDefault();
    var closeGdpr = document.querySelectorAll(".popup-page__close");
    closeGdpr.forEach((el) => {
        el.addEventListener("click", () => {
            popup.classList.remove("popup-page--active-pdf");

        });
    });
      generatePdf();
      popup.classList.add("popup-page--active-pdf");
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;

  }

}


